'use client';

import React from 'react';

import { Image } from '@depop/web-thrift-ui/Icons/Image';
import { Caption } from '@depop/web-thrift-ui/Typography';
import { LazyLoadImage } from '@depop/web-ui-kit/LazyLoadImage';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { FeedbackStars } from '@/components/FeedbackStars';
import { getFeedbackDate } from '@/modules/feedback/helpers.ts';
import { type FeedbackItem } from '@/modules/feedback/types.ts';
import { getLargestPictureFormatFromObject } from '@/modules/images/helpers';

type Props = {
  item: FeedbackItem;
};

export function RecentFeedbackListItem({ item }: Props) {
  const t = useTranslations('product');
  const tCommon = useTranslations('common');
  const hasPreview = Object.keys(item.product.preview).length > 0;

  return (
    <li>
      <div className={styles.authorRow}>
        <FeedbackStars size="sm" rating={item.rating} />
        <Caption variant="lg-regular" className={styles.author}>
          {t('ReviewAuthor', { username: item.author.username ?? '' })}
        </Caption>
        <Caption variant="lg-regular" className={styles.date}>
          {getFeedbackDate(item.date)}
        </Caption>
      </div>
      <div className={styles.reviewRow}>
        <div className={styles.imgWrapper}>
          {hasPreview ? (
            <LazyLoadImage
              width={54}
              height={54}
              alt=""
              src={getLargestPictureFormatFromObject(item.product.preview)}
            />
          ) : (
            <div
              className={styles.imgPlaceholder}
              role="img"
              aria-label={tCommon('FeedbackProductImageUnavailable')}
            >
              <Image size="md" />
            </div>
          )}
        </div>
        <Caption variant="lg-regular" className={styles.reviewContent}>
          {item.text}
        </Caption>
      </div>
    </li>
  );
}
